import { Component, Output, EventEmitter, Input, OnChanges, OnInit, ChangeDetectorRef } from "@angular/core"
import { FormControl } from "@angular/forms"
import { map, startWith } from "rxjs/operators"
import { environment } from "src/environments/environment"

@Component({
	selector: "app-basic-autocomplete",
	templateUrl: "./basic-autocomplete.component.html",
	styleUrls: ["./basic-autocomplete.component.scss"]
})
export class BasicAutocompleteComponent implements OnInit, OnChanges {
	@Output() placeSelected = new EventEmitter<any>()
	// TODO: rimuovere parametro "index"
	@Input() index: any
	@Input() elementLabel: string
	@Input() elementList: any
	@Input() elementProperty: any
	@Input() elementPlaceholder: any

	elementControl = new FormControl()
	elementOptions: any
	environment = environment
	autocomplete: any
	listLoaded = false

	constructor(private cdr: ChangeDetectorRef) {}

	ngOnInit() {
		this._initAutoComplete()
	}

	ngOnChanges(changes) {
		this.elementControl.setValue(this.elementLabel || "")
		this.elementLabel = changes.elementLabel?.currentValue || ""

		if (!changes.index) {
			this._initAutoComplete()
			this.cdr.detectChanges()
		}
	}

	emitElement(e) {
		this.elementControl.setValue(this.getOptionDesc(e))
		this.placeSelected.emit({ point: e, isValid: true })
	}

	private _filter = (value: string | any, list): string[] => {
		return list.filter(option =>
			this.getOptionDesc(option)
				.toLowerCase()
				.includes(
					typeof value === "string"
						? value.toLowerCase()
						: this.getOptionDesc(value)
						? this.getOptionDesc(value).toLowerCase()
						: ""
				)
		)
	}

	private _initAutoComplete() {
		if (this.elementList && this.elementList.length) {
			this.elementOptions = this.elementControl.valueChanges.pipe(
				startWith(""),
				map(value => this._filter(value as string, this.elementList))
			)
		}
	}

	public getOptionDesc(option) {
		if (this.elementProperty) {
			if (option && this.elementProperty.indexOf(",") !== -1 && this.elementProperty.split(",").length > 1) {
				let optionORIG = JSON.parse(JSON.stringify(option))
				let elProp = JSON.parse(JSON.stringify(option))
				elProp = elProp[this.elementProperty.split(",")[0]]
				elProp = elProp[optionORIG[this.elementProperty.split(",")[1]]]
				return elProp
			} else {
				return option[this.elementProperty]
			}
		} else {
			return option
		}
	}
}
